import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;
const CBID = "b8a9c897-57ae-4b60-9310-75a48bda6f6b";
const CB_DOMAINS = ["infinityfeedback.com", "www.infinityfeedback.com"];
let gaLoaded = false;

const injectGa = () => {
  if (gaLoaded || !GA_ID) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true });
};

export const GALoader = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!GA_ID) return;
    const privateStudio = pathname.startsWith("/studio");
    window[`ga-disable-${GA_ID}`] = privateStudio;
    if (privateStudio) return;
    const host = window.location.hostname;
    const cookiebotActive = CB_DOMAINS.includes(host);

    if (cookiebotActive && !document.getElementById("Cookiebot")) {
      const cb = document.createElement("script");
      cb.id = "Cookiebot";
      cb.src = "https://consent.cookiebot.com/uc.js";
      cb.setAttribute("data-cbid", CBID);
      cb.setAttribute("data-blockingmode", "auto");
      cb.type = "text/javascript";
      document.head.prepend(cb);
    }

    const onConsent = () => {
      if (window.Cookiebot?.consent?.statistics) injectGa();
    };
    if (cookiebotActive) {
      window.addEventListener("CookiebotOnConsentReady", onConsent);
      window.addEventListener("CookiebotOnAccept", onConsent);
      if (window.Cookiebot?.consent?.statistics) injectGa();
    } else {
      // Dominio non gestito da Cookiebot (es. preview): GA4 parte direttamente
      injectGa();
    }
    return () => {
      window.removeEventListener("CookiebotOnConsentReady", onConsent);
      window.removeEventListener("CookiebotOnAccept", onConsent);
    };
  }, [pathname]);
  return null;
};
